var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("pga-data-table", {
    attrs: {
      title: "Business Startup External Project Modules",
      headers: _vm.headers,
      data: _vm.customerOrderList,
      loading: _vm.isLoading,
      "show-expand": "",
      "group-by": "ACOM",
      "show-group-by": "",
    },
    on: { "row-clicked": _vm.details },
    scopedSlots: _vm._u([
      {
        key: "footer",
        fn: function () {
          return [
            _c("pga-switch", {
              staticClass: "pa-0 pl-2",
              staticStyle: { position: "absolute" },
              attrs: { label: "Show Closed" },
              on: { change: _vm.getCustomerOrdersClosed },
              model: {
                value: _vm.showClosed,
                callback: function ($$v) {
                  _vm.showClosed = $$v
                },
                expression: "showClosed",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }